import { isEmpty } from "./validationUtil";

/**
 *  const holidayBody = {
 *      holidayDate: "YYYY-MM-DD",
 *      name: "Holiday Name",
 *      description: "Optional description",
 *  };
 * @param {*} holidayObject
 * @returns {boolean} true if valid, false otherwise
 */
export const validateHolidayObject = (holidayObject) => {
    var isValid = holidayObject.hasOwnProperty("holidayDate") && !isEmpty(holidayObject.holidayDate);
    isValid = isValid && holidayObject.hasOwnProperty("name") && !isEmpty(holidayObject.name) && holidayObject.name.trim().length > 0;

    return isValid;
};
